module.exports = __webpack_public_path__ + "img/MCD_Instore_Half_Teaser_01.fea30972.jpg";